import React from 'react';

const DateFilter = ({ startDate, setStartDate, endDate, setEndDate }) => {
    return (
        <div className="w-full flex flex-row md:items-center gap-4 mb-4">
            <div className="w-full flex flex-col justify-center items-center">
                <label htmlFor="startDate" className="block text-sm font-medium">Fecha inicio</label>
                <input 
                    type="date" 
                    id="startDate"
                    className="border rounded px-3 py-1" 
                    value={startDate} 
                    onChange={e => setStartDate(e.target.value)} 
                />
            </div>
            <div className="w-full flex flex-col justify-center items-center">
                <label htmlFor="endDate" className="block text-sm font-medium">Fecha fin</label>
                <input 
                    type="date" 
                    id="endDate"
                    className="border rounded px-3 py-1"  
                    value={endDate} 
                    onChange={e => setEndDate(e.target.value)} 
                />
            </div>
        </div>
    );
};

export default DateFilter;